import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const FacebookAd = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12723"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12723)">
          <rect
            x="-3"
            width="121"
            height="112"
            rx="5.09677"
            fill="#BFCDFF"
          />
          <rect
            x="10.0667"
            y="28.0625"
            width="26.4395"
            height="43.004"
            rx="4.61895"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <rect
            x="18.0181"
            y="30.7703"
            width="11.239"
            height="1.27419"
            rx="0.637097"
            fill="#1E1E1E"
          />
          <rect
            x="19.6233"
            y="38.2561"
            width="57.6573"
            height="50.6492"
            rx="0.796371"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <rect
            x="19.1455"
            y="62.625"
            width="58.6129"
            height="1.27419"
            fill="#1E1E1E"
          />
          <rect
            x="19.1455"
            y="42.875"
            width="58.6129"
            height="0.955645"
            fill="#1E1E1E"
          />
          <rect
            x="23.605"
            y="53.0686"
            width="49.0564"
            height="2.54839"
            rx="0.637097"
            fill="#8C8C8C"
          />
          <rect
            x="23.605"
            y="57.5283"
            width="38.8629"
            height="2.54839"
            rx="0.637097"
            fill="#8C8C8C"
          />
          <rect
            x="31.25"
            y="47.9718"
            width="12.1048"
            height="2.54839"
            rx="0.637097"
            fill="#8C8C8C"
          />
          <circle
            cx="26.1534"
            cy="48.6089"
            r="2.54839"
            fill="#8C8C8C"
          />
          <circle
            cx="68.5201"
            cy="40.6452"
            r="0.955645"
            fill="#FFB700"
          />
          <circle
            cx="71.7056"
            cy="40.6451"
            r="0.955645"
            fill="#FFB700"
          />
          <circle
            cx="74.8912"
            cy="40.6451"
            r="0.955645"
            fill="#FFB700"
          />
          <circle
            cx="52.9113"
            cy="70.9074"
            r="1.91129"
            fill="#0C5CEF"
          />
          <path
            d="M45.4549 70.0025C45.5184 69.9133 45.6509 69.9133 45.7144 70.0025L56.2655 84.831C56.3405 84.9365 56.2651 85.0827 56.1357 85.0827H35.0336C34.9042 85.0827 34.8288 84.9365 34.9038 84.831L45.4549 70.0025Z"
            fill="#DDEBDB"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <path
            d="M54.6932 75.0875C54.7568 74.9995 54.8878 74.9995 54.9514 75.0875L55.3339 74.8113L54.9514 75.0875L61.9877 84.83C62.0637 84.9354 61.9885 85.0826 61.8586 85.0826H47.786C47.6561 85.0826 47.5809 84.9354 47.6569 84.83L54.6932 75.0875Z"
            fill="#DDEBDB"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <rect
            x="72.5022"
            y="20.4174"
            width="33.4476"
            height="33.4476"
            rx="16.7238"
            fill="white"
          />
          <rect
            x="72.5022"
            y="20.4174"
            width="33.4476"
            height="33.4476"
            rx="16.7238"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <g clipPath="url(#clip0_1529_12723)">
            <g clipPath="url(#clip1_1529_12723)">
              <path
                d="M81.7339 39.961C81.7339 40.6765 81.894 41.2235 82.1034 41.5553C82.215 41.7441 82.3756 41.9007 82.5691 42.0091C82.7625 42.1175 82.9818 42.1739 83.2047 42.1725C83.7431 42.1725 84.2356 42.0424 85.1848 40.7572C85.9451 39.7275 86.8411 38.2855 87.4446 37.3749L88.4655 35.8399C89.1747 34.7738 89.9942 33.5887 90.9367 32.7828C91.7044 32.1297 92.5332 31.7655 93.3674 31.7655C94.7678 31.7655 96.1018 32.5597 97.1227 34.0492C98.24 35.6805 98.7843 37.7352 98.7843 39.8557C98.7843 41.1162 98.5304 42.0424 98.0984 42.7742C97.6817 43.4819 96.8655 44.1889 95.4969 44.1889V42.1725C96.6687 42.1725 96.9592 41.1188 96.9592 39.9129C96.9592 38.1944 96.5498 36.2874 95.6478 34.9247C95.0077 33.9581 94.1783 33.3675 93.2657 33.3675C92.2787 33.3675 91.4844 34.096 90.5918 35.395C90.1172 36.0851 89.63 36.9261 89.083 37.8751L88.4808 38.9158C87.2711 41.0147 86.9647 41.4928 86.3599 42.2818C85.3017 43.6685 84.3965 44.1889 83.2047 44.1889C81.791 44.1889 80.8971 43.5898 80.3467 42.687C79.8914 41.9514 79.6694 40.9861 79.6694 39.8862L81.7339 39.961Z"
                fill="#0081FB"
              />
              <path
                d="M81.2969 34.1916C82.2433 32.7639 83.6092 31.7655 85.1758 31.7655C86.0831 31.7655 86.985 32.0257 87.9268 32.7808C88.9571 33.6036 90.0537 34.9585 91.4249 37.1915L91.9161 37.9928C93.1019 39.9259 93.7772 40.9198 94.1713 41.3894C94.6791 41.9917 95.0354 42.1699 95.4966 42.1699C96.6684 42.1699 96.9589 41.1162 96.9589 39.9103L98.78 39.8544C98.78 41.1149 98.5261 42.0411 98.0941 42.7729C97.6814 43.4819 96.8652 44.1889 95.4966 44.1889C94.6459 44.1889 93.8921 44.0081 93.0587 43.2386C92.4179 42.648 91.6689 41.5988 91.0926 40.6557L89.3785 37.8536C88.5184 36.4474 87.7294 35.3989 87.2728 34.9266C86.781 34.4134 86.1502 33.7968 85.1426 33.7968C84.3271 33.7968 83.6345 34.3569 83.0549 35.2135L81.2969 34.1916Z"
                fill="url(#paint0_linear_1529_12723)"
              />
              <path
                d="M85.1429 33.7968C84.3274 33.7968 83.6348 34.3569 83.0552 35.2135C82.2357 36.4239 81.7339 38.227 81.7339 39.961C81.7339 40.6765 81.894 41.2235 82.1034 41.5553L80.3434 42.687C79.8914 41.9514 79.6694 40.9861 79.6694 39.8862C79.6694 37.8861 80.2304 35.8015 81.2972 34.1916C82.2437 32.7639 83.6095 31.7655 85.1761 31.7655L85.1429 33.7968Z"
                fill="url(#paint1_linear_1529_12723)"
              />
            </g>
          </g>
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_1529_12723"
            x1="83.8126"
            y1="37.6552"
            x2="96.9714"
            y2="38.3343"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0064E1" />
            <stop
              offset="0.4"
              stopColor="#0064E1"
            />
            <stop
              offset="0.83"
              stopColor="#0073EE"
            />
            <stop
              offset="1"
              stopColor="#0082FB"
            />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1529_12723"
            x1="82.4224"
            y1="40.8066"
            x2="82.4224"
            y2="36.0584"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0082FB" />
            <stop
              offset="1"
              stopColor="#0064E0"
            />
          </linearGradient>
          <clipPath id="clip0_1529_12723">
            <rect
              width="19.1129"
              height="19.1129"
              fill="white"
              transform="translate(79.6694 27.5846)"
            />
          </clipPath>
          <clipPath id="clip1_1529_12723">
            <rect
              width="19.1129"
              height="12.4234"
              fill="white"
              transform="translate(79.6694 31.7655)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
